<template>
  <div>
    <report-designer />
  </div>
</template>

<script>
  import ReportDesigner from '@/components/reports/ReportDesigner.vue'

  export default {
    components: {
      ReportDesigner
    }
  }
</script>
